import { Image, Container, Row, Col } from 'react-bootstrap';
import Sidebar from './AnimatedList';
import "./Services.css";

function Vessel() {
    return (
        <>
            <Image className="fade-in responsive-img" src="https://windward.ai/wp-content/uploads/2025/05/shipping-logistics-featured-scaled.jpg" height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col md={8}>
                        <h1 className='text-center my-2 text-decoration-underline'><strong>Vessel Chartering</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>Our Chartering division works intimately with transport proprietors to contract vessels for our client's shipments (both part and full freight) by checking and arranging all specialized, legitimate and business angles. In doing as such, we can assist with limiting any gamble encompassing the transportation of our client's transfers, by providing them with transport that is completely agreeable with global guidelines.</p>
                    </Col>
                    <Col md={4}>
                    <Sidebar/>
                    </Col>
                </Row>
            </Container>
           
        </>
    )
}

export default Vessel